<script lang="ts">
	import { onMount, onDestroy } from "svelte";

	import { fade, fly } from "svelte/transition";
	import { yyyy, zzzz } from "../store.svelte";
	import { toast } from "../lib/toast.svelte.ts";

	let ready: boolean = $state(false);

	const url: string = yyyy.uri.api;

	interface settingprops {
		livewire: string;
		owner: string;
		propagate: string[];
		ispublic: boolean;
		ispinned: boolean;
		wireident: string;
		description: string;
		displaySettings: boolean;
	}

	let {
		livewire,
		owner,
		propagate,
		ispublic,
		ispinned,
		wireident,
		description,
		displaySettings = $bindable(),
	}: settingprops = $props();

	let fork_text: string = $state("");
	let fork_is_loading: boolean = $state(false);
	let bad_forking_name: boolean = $state(false);
	let bad_forking_reason: string = $state("");

	let share_input_active: boolean = $state(false);
	let sharetag: string = $state();
	let shareInput: HTMLElement = $state();

	let delete_text: string = $state("");
	let deleting_livewire: boolean = $state(false);

	let description_text: string = $state(description || "");
	let updating_description: boolean = $state(false);

	let togglePublicity = async function () {
		event?.preventDefault();

		let _body = JSON.stringify({ ispublic: !ispublic });
		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let fetchopts = {
			method: "PATCH",
			mode: "cors",
			body: _body,
			headers: _hdrs,
		};
		const response = await fetch(
			`${url}/livewires?wireident=eq.${wireident}`,
			fetchopts,
		);
		if (response.ok) {
			//console.log(response);
			ispublic = !ispublic;
		} else {
			const data = await response.json();
			console.log(data);
			let toast_message = {
				message: `Hmmm...thats not right. Please try again.`,
				type: "is-danger",
				dismissible: false,
				duration: 6500,
				position: "bottom-right",
			};
			zzzz.emit("toast", toast_message);
		}
		zzzz.emit("getlivewires");
	};

	let toggleIsPinned = async function () {
		event?.preventDefault();

		let _body = JSON.stringify({ ispinned: !ispinned });
		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let fetchopts = {
			method: "PATCH",
			mode: "cors",
			body: _body,
			headers: _hdrs,
		};
		const response = await fetch(
			`${url}/livewires?wireident=eq.${wireident}`,
			fetchopts,
		);
		if (response.ok) {
			//console.log(response);
			ispinned = !ispinned;
		} else {
			const data = await response.json();
			console.log(data);
			let toast_message = {
				message: `Only one livewire at a time can be featured.`,
				type: "is-danger",
				dismissible: false,
				duration: 6500,
				position: "bottom-right",
			};
			zzzz.emit("toast", toast_message);
		}
		zzzz.emit("getlivewires")
		displaySettings = false;
	};

	let shared_with_check = async (inItem: string) => {
		if (inItem === yyyy.sesh.tokeninfo.email) {
			let toast_message = {
				message:
					"You are the owner of this livewire, you can't share it with yourself.",
				type: "is-warning",
				dismissible: false,
				duration: 6500,
				position: "bottom-right",
			};
			zzzz.emit("toast", toast_message);
			return;
		}

		let _body = JSON.stringify({ sharee: inItem, wireident: wireident });
		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let fetchopts = { method: "PUT", body: _body, headers: _hdrs };
		//console.log(_body);
		const response = await fetch(
			`${url}/propagate?sharee=eq.${inItem}&wireident=eq.${wireident}`,
			fetchopts,
		);
		if (response.ok) {
			//console.log("shared_with_check is good");
			zzzz.emit("getlivewires");
			return true;
		} else {
			let toast_message = {
				message: "The email you supplied cannot be found.",
				type: "is-danger",
				dismissible: false,
				duration: 6500,
				position: "bottom-right",
			};
			zzzz.emit("toast", toast_message);
			const data = await response.json();
			//console.log(data);
			//console.log("shared_with_check is bad");
			return false;
		}
	};

	let shared_with_delete = async (inItem: string) => {
		//let _body = JSON.stringify({email: inItem, livewire: livewire})
		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let fetchopts = { method: "DELETE", headers: _hdrs };
		//console.log(_body)
		const response = await fetch(
			`${url}/propagate?sharee=eq.${inItem}&wireident=eq.${wireident}`,
			fetchopts,
		);
		if (response.ok) {
			//console.log(`${inItem} was deleted`);
			zzzz.emit("getlivewires");
			return true;
		} else {
			const data = await response.json();
			//console.log(data);
			//console.log(`Could not delete ${inItem}`);
			return false;
		}
	};

	let sharedWithInputKeyUp = async (inkey: KeyboardEvent) => {
		if (!(inkey.key === "Enter" || inkey.key === "Escape")) {
			return false;
		}

		if (inkey.key === "Escape") {
			shareInput.blur();
		}

		//console.log("Enter pressed");
		if (sharetag === "" || sharetag === undefined) {
			return false;
		}
		shared_with_check(sharetag);
		sharetag = "";
	};

	let updateDescription = async () => {
		if (description_text.trim() === (description || "")) {
			return; // No changes
		}

		updating_description = true;
		let _body = JSON.stringify({ description: description_text.trim() });
		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let fetchopts = { method: "PATCH", headers: _hdrs, body: _body };
		const response = await fetch(
			`${url}/livewires?wireident=eq.${wireident}`,
			fetchopts,
		);

		if (response.ok) {
			toast.success("Description updated successfully");
			zzzz.emit("getlivewires");
		} else {
			toast.error("Failed to update description");
			description_text = description || ""; // Reset to original
		}
		updating_description = false;
	};

	let fork_livewire = async () => {
		fork_is_loading = true;
		let _body = JSON.stringify({
			wireident: wireident,
			fork_name: fork_text.trim(),
		});
		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let fetchopts = { method: "POST", headers: _hdrs, body: _body };
		const response = await fetch(
			`${url}/rpc/create_livewire_fork_existing`,
			fetchopts,
		);

		if (response.ok) {
			let resp = await response.json();
			console.log(resp);
			displaySettings = false;

			zzzz.emit("getlivewires");
			return true;
		} else {
			const data = await response.json();
			console.log(data);
			return false;
		}
	};

	let namecheck = async () => {
		if (fork_text === "") {
			bad_forking_name = false;
			return;
		}
		if (fork_text.trim().length < 6) {
			bad_forking_name = true;
			bad_forking_reason =
				"The suggested name is too short, it must be at least 6 characters";
			return;
		}
		let _body = JSON.stringify({ potential_name: fork_text.trim() });
		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let fetchopts = { method: "post", body: _body, headers: _hdrs };
		const response = await fetch(
			`${url}/rpc/create_livewire_name_check`,
			fetchopts,
		);
		if (response.ok) {
			//console.log(response);

			bad_forking_name = false;
		} else {
			let resp = await response.json();
			bad_forking_name = true;
			bad_forking_reason = `${resp.details} ${resp.hint}`;
		}
	};

	let delete_livewire = async () => {
		deleting_livewire = true;
		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let fetchopts = { method: "DELETE", headers: _hdrs };
		const response = await fetch(
			`${url}/livewires?wireident=eq.${wireident}`,
			fetchopts,
		);

		if (response.ok) {
			console.log(`${livewire} was deleted`);
			zzzz.emit("getlivewires");
			displaySettings = false;
			return true;
		} else {
			const data = await response.json();
			console.log(data);
			return false;
		}
	};

	onMount(() => {});

	onDestroy(() => {});
</script>

<div id="changer-backdrop" transition:fade={{ duration: 275 }}></div>
<!-- <svelte:window on:pushstate={routing} /> -->
<div
	class="column is-two-thirds elevate"
	transition:fly={{ y: 200, delay: 275, duration: 475 }}
>
	<div class="card lvwr-card" class:zeroBG={!ready} style="background-color: white;">
		<header class="card-header">
			<p class="card-header-title">Settings for {livewire}</p>
		</header>

		<div class="card-content settings">
			{#if yyyy.sesh.tokeninfo.email == owner}
				<div
					class="content box"
					class:not-active={delete_text || share_input_active}
				>
					<!-- Toggle make Livewire public-->
					<fieldset>
						<div class="toggle-field">
							<label class="toggle-container">
								<span class="toggle-label">Make {livewire} public</span>
								<input
									id="publicswitch"
									type="checkbox"
									checked={ispublic}
									onclick={togglePublicity}
								/>
								<span class="toggle-switch"></span>
							</label>
						</div>
					</fieldset>
				</div>
				<!-- <hr> <Tags bind:tags maxTags={5} /> <hr> -->
				<div
					class="content box"
					class:not-active={delete_text || share_input_active || (description_text.trim() !== (description || ""))}
				>
					<!-- Toggle make Livewire featured-->
					<fieldset>
						<div class="toggle-field">
							<label class="toggle-container">
								<span class="toggle-label">Feature {livewire}</span>
								<input
									id="pinswitch"
									type="checkbox"
									checked={ispinned}
									onclick={toggleIsPinned}
								/>
								<span class="toggle-switch"></span>
							</label>
						</div>
					</fieldset>
				</div>

				<div class="field">
					<div class="content box" class:not-active={delete_text || fork_text || (description_text.trim() !== (description || ""))}>
						<!-- Share LiveWire tag input-->
						<label class="label" for="shared-with-emails"
							>Share {livewire} with other users.</label
						>
						<div id="fake-input" class="field is-grouped is-grouped-multiline">
							{#each propagate as share}
								<div class="control" transition:fade|local>
									<div class="tags has-addons are-medium">
										<span class="tag is-link">{share.sharee}</span>
										<a
											class="tag is-delete"
											aria-label="Click here to remove"
											onclick={() => {
												shared_with_delete(share.sharee);
											}}
										></a>
									</div>
								</div>
							{/each}
							<p class="cotrol">
								<input
									id="shared-with-emails"
									class="input"
									style="border: none; box-shadow: none;}"
									placeholder="Enter an email"
									onkeyup={sharedWithInputKeyUp}
									onfocus={() => {
										share_input_active = true;
									}}
									onblur={() => {
										share_input_active = false;
									}}
									bind:value={sharetag}
									bind:this={shareInput}
								/>
							</p>
						</div>
					</div>
				</div>
			{/if}

			{#if yyyy.sesh.tokeninfo.email == owner}
				<div
					class="content box"
					class:not-active={delete_text || share_input_active || fork_text}
				>
					<!-- Edit livewire description -->
					<fieldset>
						<div class="field">
							<p>
								Update the description for {livewire}.
							</p>
							<div class="control is-expanded">
								<textarea
									class="textarea"
									placeholder="Enter a description for your livewire"
									bind:value={description_text}
									rows="3"
								></textarea>
							</div>
						</div>
					</fieldset>
				</div>
			{/if}

			<div
				class="content box"
				class:not-active={delete_text || share_input_active || (description_text.trim() !== (description || ""))}
			>
				<!-- Fork livewire text input-->
				<fieldset>
					<div class="field">
						<label class="label">Fork {livewire}</label>
						<p>
							Forking {livewire} will create a copy for your own personal use.
						</p>
						<div class="control is-expanded">
							<input
								class="input is-fullwidth"
								class:is-danger={bad_forking_name}
								type="text"
								placeholder="New livewire name"
								onkeyup={namecheck}
								bind:value={fork_text}
							/>
						</div>
						{#if bad_forking_name}
							<p class="help is-danger">{bad_forking_reason}</p>
						{/if}
					</div>
				</fieldset>
			</div>

			{#if yyyy.sesh.tokeninfo.email == owner}
				<div class="content box" class:not-active={fork_text || share_input_active || (description_text.trim() !== (description || ""))}>
					<!-- Delete livewire text input-->
					<fieldset>
						<div class="field">
							<label class="label" for="delete-livewire">Delete {livewire}</label>
							<p>
								Deleteing a livewire is a permanent operation and cannot be undone.<br
								/>
								To continue, type "DELETE {livewire}" below.
							</p>
							<div class="control is-expanded">
								<input
									id="delete-livewire"
									class="input is-fullwidth"
									type="text"
									placeholder="DELETE {livewire}"
									bind:value={delete_text}
									disabled={fork_text}
								/>
							</div>
						</div>
					</fieldset>
				</div>
			{/if}
			<!-- todo: add a block to modify the text search -->
		</div>

		<footer class="card-footer">
			<div class="card-footer-item sign-in-up-footer">
				<button
					class="button lvwr-toggle"
					onclick={() => {
						displaySettings = false;
					}}
					>Go Back
				</button>

				{#if delete_text}
					<button
						class="button lvwr-toggle-cancel"
						onclick={delete_livewire}
						disabled={delete_text !== `DELETE ${livewire}`}
						class:is-loading={deleting_livewire}
						transition:fly|local
					>
						Delete {livewire}
					</button>
				{/if}
				{#if description_text.trim() !== (description || "")}
					<button
						class="button lvwr-toggle"
						onclick={updateDescription}
						disabled={updating_description}
						class:is-loading={updating_description}
						transition:fly|local
					>
						Update Description
					</button>
				{/if}
				{#if fork_text}
					<button
						class="button lvwr-toggle"
						onclick={fork_livewire}
						disabled={bad_forking_name}
						class:is-loading={fork_is_loading}
						transition:fly|local
					>
						Fork {livewire}
					</button>
				{/if}
			</div>
		</footer>
	</div>
</div>

<style>
	.elevate {
		position: fixed;
		z-index: 7;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		width: 66%;
		max-width: 1275px;
		min-width: 375px;
		height: fit-content;
		max-height: 90vh;
	}

	.not-active {
		filter: blur(2px) opacity(70%);
	}

	.sign-in-up-footer {
		justify-content: space-between;
	}

	.settings {
		max-height: 75vh;
		overflow-y: auto;
	}

	#fake-input {
		font-size: inherit;
		padding: 0.4em;
		margin: 0 0 0.5em 0;
		box-sizing: border-box;
		border: 1px solid #ccccccc7;
		border-radius: 5px;
	}

	#changer-backdrop {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 5;
		backdrop-filter: grayscale(1) blur(8.775px) brightness(95%);
	}

	/* Override zeroBG class to ensure white background */
	.card.lvwr-card {
		background-color: white !important;
	}

	.zeroBG {
		background-color: white !important;
		box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1) !important;
	}

	/* Modern toggle switch styles */
	.toggle-field {
		padding: 0.5rem 0;
	}

	.toggle-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
		user-select: none;
	}

	.toggle-label {
		font-weight: 500;
		color: #363636;
		flex: 1;
	}

	.toggle-container input[type="checkbox"] {
		opacity: 0;
		width: 0;
		height: 0;
		position: absolute;
	}

	.toggle-switch {
		position: relative;
		display: inline-block;
		width: 50px;
		height: 24px;
		background-color: #ccc;
		border-radius: 4px;
		transition: background-color 0.3s;
		flex-shrink: 0;
	}

	.toggle-switch::after {
		content: '';
		position: absolute;
		width: 18px;
		height: 18px;
		left: 3px;
		top: 3px;
		background-color: white;
		border-radius: 4px;
		transition: transform 0.3s;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	}

	input[type="checkbox"]:checked + .toggle-switch {
		background-color: #ff3e00;
	}

	input[type="checkbox"]:checked + .toggle-switch::after {
		transform: translateX(26px);
	}

	input[type="checkbox"]:disabled + .toggle-switch {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.toggle-container:hover .toggle-switch:not(:disabled) {
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
	}

	/* Improved box styling */
	.content.box {
		margin-bottom: 1rem;
		padding: 1.25rem;
		border-radius: 6px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		transition: box-shadow 0.2s;
	}

	.content.box:hover:not(.not-active) {
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
	}

	/* Improved card header */
	.card-header-title {
		font-size: 1.25rem;
		font-weight: 600;
	}

	/* Improved input styling */
	.input {
		transition: border-color 0.2s, box-shadow 0.2s;
	}

	.input:focus {
		border-color: #3273dc;
		box-shadow: 0 0 0 3px rgba(50, 115, 220, 0.1);
	}

	.input.is-danger:focus {
		border-color: #ff3860;
		box-shadow: 0 0 0 3px rgba(255, 56, 96, 0.1);
	}
</style>
